import Alert, { AlertColor } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export interface FeedbackMessage {
  text: string;
  severity: AlertColor;
}

interface FeedbackSnackbarProps {
  message: FeedbackMessage | null;
  onClose: () => void;
}

const FeedbackSnackbar = ({ message, onClose }: FeedbackSnackbarProps) => (
  <Snackbar
    open={Boolean(message)}
    autoHideDuration={7000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <Alert
      elevation={6}
      variant="filled"
      severity={message?.severity || 'info'}
      onClose={onClose}
      sx={{ width: '100%' }}
    >
      {message?.text}
    </Alert>
  </Snackbar>
);

export default FeedbackSnackbar;
